module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 18 18\"><path d=\"M9 11.9l-9-6v7.5c0 .9.7 1.6 1.6 1.6h14.7c.9 0 1.6-.7 1.6-1.6V6v-.2L9 11.9zm0-1.6l8.5-5.9c-.3-.2-.9-.4-1.3-.4H1.8c-.4 0-1 .2-1.3.4L9 10.3z\" fill-rule=\"evenodd\" clip-rule=\"evenodd\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./icons/mail.svg
// module id = 72
// module chunks = 0